import { Link } from "react-router-dom";
import { LogoMark } from "../components/Logo";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#FAF7F2] py-16" data-testid="privacy-page">
      <div className="mx-auto max-w-2xl px-6">
        <Link to="/" className="flex items-center gap-3">
          <LogoMark size={30} />
          <span className="font-serif text-lg text-[#262320]">Beyond the Pain</span>
        </Link>
        <h1 className="mt-12 font-serif text-4xl font-light text-[#262320]">Privacy Policy</h1>
        <div className="mt-8 space-y-6 text-sm leading-relaxed text-[#6E6862]">
          <p>
            When you register for a SoulSyncHealing workshop, we collect your full name and email address. This
            information is used only to manage your registration, process your payment, and send you workshop-related
            emails such as your confirmation and Zoom joining link.
          </p>
          <p>
            Payments are processed securely by Razorpay. We never see or store your card, UPI or banking details — only
            a transaction reference and payment status.
          </p>
          <p>
            We do not sell, rent or share your personal information with third parties for marketing. Your data is
            stored securely and is accessible only to the workshop facilitator.
          </p>
          <p>
            You may ask us to correct or delete your information at any time by writing to the contact email listed on
            the workshop page.
          </p>
          <p className="text-xs italic">
            This is a starter policy provided as a placeholder — please have it reviewed and personalised before
            accepting real payments.
          </p>
        </div>
        <Link
          to="/"
          className="mt-12 inline-block rounded-full border border-[#5E7D6A] px-8 py-3 text-sm text-[#5E7D6A] hover:bg-[#5E7D6A] hover:text-white"
          data-testid="privacy-back-link"
        >
          ← Back to the workshop
        </Link>
      </div>
    </div>
  );
}
